import React, { useState, useEffect } from 'react';
import './Quality.scss';

const Quality = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);
      observer.observe(entry.target);
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });

  return (
    <div className="quality">
      <div id="Quality" className="qualityFirst" ref={setTarget}>
        <div className="qualityContentsTitle">
          <div>난로의 고온을 고려한</div>

          <div>견고하고 빈틈없는 내구도와 디테일</div>
        </div>
        <div className="qualityContentsInfo">
          <p> 고온의 난로 위에서 동작하는 극한 환경과</p>
          <p>다양한 돌발 상황이 존재하는 캠핑장의 환경을 고려하여</p>
          <p>TUF는 안정성과 디테일을 중심으로 설계했습니다.</p>
          <br />
          <p> 어떤 상황에서도 문제 없이 작동할 수 있도록</p>
          <p>다양한 환경을 고려한 수많은 테스트를 진행했습니다.</p>
        </div>
      </div>
      <div className="qualityImagemain">
        <img className="qualityImage" src="/images/Qual2.jpg" alt="quality" />
        <img
          className="qualityImage"
          src="/images/Heatcamera2.jpg"
          alt="quality"
        />
        <img className="qualityImage" src="/images/Qual3.jpg" alt="quality" />
      </div>
    </div>
  );
};

export default Quality;
